import { useState } from 'react';
import { toast } from 'react-toastify';

import fleetApi from '../../../services/api.service';

export default function useGetClientHistory() {
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Historique du paramétrage du client (création, modifications, logo,
   * templates, administrateurs), du plus récent au plus ancien.
   * @param {number} clientId - L'identifiant du client
   * @returns {Promise<object[]|null>} Les événements, ou null en cas d'erreur
   */
  const fetchHistory = async (clientId) => {
    try {
      setIsLoading(true);

      const response = await fleetApi.get(
        `/super-admin/clients/${clientId}/history`
      );

      if (response.status !== 200) {
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }

      return response.data.history;
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    fetchHistory,
  };
}
